import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles, OutlinedInput, Button } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import swal from '@sweetalert/with-react';

import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import TitleText from '../common/TitleText';
import axiosInstance, { API_URL } from '../common/Constants';

const styles = (theme) => ({
  background: {
    background: `url('/images/mypage/mypage_bg.png') #fafafa`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '120%',
    backgroundPosition: 'center top',
    [theme.breakpoints.down('sm')]: {
      backgroundSize: '200%',
    },
    [theme.breakpoints.down('xs')]: {
      backgroundSize: '250%',
    },
  },
  main: {
    width: '100%',
    // height: 'calc(100vh - 101.61px)',
    // overflowX: 'none',
    // overflowY: 'auto',
  },

  //card
  cardDiv: {
    padding: '0 30px',
    marginBottom: theme.spacing(5),
    marginTop: '23%',
    [theme.breakpoints.down('md')]: {
      marginTop: '20%',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '40%',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '45%',
    },
  },
  cardRoot: {
    width: '70%',
    margin: 'auto',
    borderRadius: '20px',
    boxShadow: '0px 10px 10px 0 rgba(0, 0, 0, 0.02)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  //프로필 이미지
  userProfileImg: {
    width: theme.spacing(17),
    height: theme.spacing(17),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
  },
  fabRoot: {
    boxShadow: 'none',
    border: '3px solid #fff',
    backgroundColor: '#808080',
    position: 'absolute',
    bottom: theme.spacing(-0.5),
    right: theme.spacing(-1),
  },

  accountInfoGrid: {
    borderRight: '1px solid #f1f1f1',
    paddingRight: '2em !important',
    [theme.breakpoints.down('md')]: {
      borderRightStyle: 'none',
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
  },
  userInfoGrid: {
    paddingLeft: '2em !important',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
  },

  accountInputGrid: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
  accountInput: {
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      paddingRight: theme.spacing(0),
    },
  },

  infoInput: {
    marginBottom: theme.spacing(2),
  },

  infoTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '1em',
    fontWeight: 600,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
    },
  },
  pwdCheckTitleWeb: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 'calc(8px + 1em) !important',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  pwdCheckTitleMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      // display: 'block',
      // width: '100%',
      // textAlign: 'center',
      // paddingTop: '16px !important',
      // paddingBottom: 'calc(8px + 3em) !important',
      // wordBreak: 'keep-all',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      width: '100%',
      textAlign: 'center',
      wordBreak: 'keep-all',
      paddingTop: '8px !important',
      paddingBottom: 'calc(8px + 3em) !important',
    },
  },
  pwdInputDisabled: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
  },

  //개인정보
  infoContainer: {
    margin: theme.spacing(4, 7, 2),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(4, 3, 2),
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(4, 1, 2),
    },
  },
  chipRoot: {
    width: '100%',
  },
  chipLabel: {
    fontWeight: 'bold',
  },
  infoModMonthDateText: {
    paddingLeft: '0.2em',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },

  outlinedSelect: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: '24px !important',
    },
  },
  outlinedInput: {
    [theme.breakpoints.down('sm')]: {
      padding: '18.5px 7px',
    },
  },

  //버튼
  submitBtn: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    padding: theme.spacing(2, 4),
    '&:hover': {
      backgroundColor: 'rgba(29, 27, 84, 0.85)',
    },
  },
  cancelBtn: {
    backgroundColor: '#f0f0f0',
  },
});

class MyInfoMod extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userInfo: JSON.parse(localStorage.getItem(`${localStorage.getItem('loggedin')}_status`)),
      selectedImg: null, //바꿀 프로필 이미지
      email: '',
      name: '',
      phone: '',
      phoneFirst: '',
      phoneMiddle: '',
      phoneLast: '',
      gender: '',
      age_range: '',
      birthday: '',
      img: '',
      birthdayMonth: '',
      birthdayDate: '',
      password: '',
      passwordCheck: '',
      st: '',
      isImageSelected: false, //새로운 이미지 선택했는지 boolean
    };

    //this.imgPicker = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeNum = this.handleChangeNum.bind(this);
  }

  componentDidMount() {
    if (!localStorage.getItem('loggedin')) {
      this.props.history.replace('/login');
    } else {
      // this.setState({ userInfo: JSON.parse(sessionStorage.getItem(`${sessionStorage.getItem('loggedin')}_status`)) });
      this.getUserInfo(localStorage.getItem('loggedin'));
    }
  }

  componentWillUnmount() {
    this.setState({ isImageSelected: false });
  }

  getUserInfo(id) {
    axiosInstance
      .get(`${API_URL}/user/info?userId=${id}`, {})
      .then((res) => {
        // console.log(res.data);
        this.setState({
          email: res.data.email,
          name: res.data.name,
        });
        if (res.data.phone) {
          this.setState({ phoneFirst: res.data.phone.substr(0, 3) });
          if (res.data.phone.length === 10) {
            this.setState({
              phoneMiddle: res.data.phone.substr(3, 3),
              phoneLast: res.data.phone.substr(6, 4),
            });
          } else if (res.data.phone.length === 11) {
            this.setState({
              phoneMiddle: res.data.phone.substr(3, 4),
              phoneLast: res.data.phone.substr(7, 4),
            });
          }
        }
        if (res.data.gender) {
          this.setState({ gender: res.data.gender });
        }
        if (res.data.age_range) {
          this.setState({ age_range: res.data.age_range });
        }
        if (res.data.birthday) {
          this.setState({
            birthdayMonth: res.data.birthday.substr(0, 2),
            birthdayDate: res.data.birthday.substr(2, 2),
          });
        }
        if (res.data.img) {
          this.setState({ img: res.data.img });
        }
        if (res.data.st) {
          this.setState({ st: res.data.st });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  //전화번호 입력란 숫자만 입력가능
  handleChangeNum(type, e) {
    const re = /^[0-9\b]{0,4}$/;

    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ [type]: e.target.value });
    }
  }

  //프로필 이미지 변경 버튼 클릭
  clickChangeProfileImg = (event) => {
    event.preventDefault();
    // this.imgPicker.current.click();
    document.getElementById('img-picker').click();
  };

  //input 태그 -> 실제로 이미지 바꾸는 코드
  onChangeProfileImg = (event) => {
    const fileReader = new FileReader();

    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = (event) => {
      // console.log(event.target.result);
      this.setState({ img: event.target.result, isImageSelected: true }); //미리보기 바꾸기
    };
    this.setState({ selectedImg: event.target.files[0] });
  };

  uploadProfileImg(tel, bday) {
    const formData = new FormData();

    // console.log('선택한이미지');
    // console.log(this.state.selectedImg);

    if (this.state.isImageSelected) {
      //이미지 바꿨으면
      formData.append('imgFile', this.state.selectedImg);
    }
    formData.append('userId', localStorage.getItem('loggedin'));
    if (tel !== '') {
      formData.append('phone', tel);
    }
    if (bday !== '') {
      formData.append('birthday', bday);
    }
    for (const [key, value] of Object.entries(this.state)) {
      if (key === 'name' || key === 'gender' || key === 'age_range' || key === 'password') {
        // console.log(key + ' : ' + value);
        if (value !== '') {
          formData.append(key, value);
        }
      }
    }

    axiosInstance
      .put(`${API_URL}/user/`, formData)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          // alert('회원 정보가 수정되었습니다.');
          swal({
            text: '회원 정보가 수정되었습니다.',
            button: '확인',
          }).then(() => {
            this.props.history.push('mypage');
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  submit() {
    let telNo = '';
    let birthdayStr = '';
    const telRegExp = /^01([0|1|6|7|8|9]?)(\d{3,4})(\d{4,4})$/gi;
    const pwdRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z_\d\W]{8,}$/gi;

    if (this.state.password !== '') {
      if (!pwdRegExp.test(this.state.password)) {
        swal({
          text: '비밀번호는 영문, 숫자를 포함하고 8자 이상이어야 합니다.',
          button: '확인',
        }).then(() => {
          this.setState({ password: '' }, () => {
            document.getElementById('password').focus();
          });
        });
        return false;
      }
      if (this.state.passwordCheck !== '') {
        if (this.state.password !== this.state.passwordCheck) {
          swal({
            text: '입력하신 비밀번호와 일치하지 않습니다.',
            button: '확인',
          }).then(() => {
            this.setState({ passwordCheck: '' }, () => {
              document.getElementById('passwordCheck').focus();
            });
          });
          return false;
        }
      }
    }
    if (this.state.phoneFirst && this.state.phoneMiddle && this.state.phoneLast) {
      telNo = this.state.phoneFirst + this.state.phoneMiddle + this.state.phoneLast;
      // console.log(telNo);
      if (telNo !== '') {
        if (!telRegExp.test(telNo)) {
          swal({
            text: '휴대폰 번호를 올바르게 입력해주세요.',
            button: '확인',
          }).then(() => {
            this.setState({ phoneMiddle: '', phoneLast: '' });
          });
          return false;
        } else {
          this.setState({ phone: telNo });
        }
      }
    }
    if (this.state.birthdayMonth && this.state.birthdayDate) {
      birthdayStr = this.state.birthdayMonth + this.state.birthdayDate;
      if (birthdayStr !== '') {
        if (
          this.state.birthdayMonth === '04' ||
          this.state.birthdayMonth === '06' ||
          this.state.birthdayMonth === '09' ||
          this.state.birthdayMonth === '11'
        ) {
          if (this.state.birthdayDate === '31') {
            swal({
              text: '일자를 다시 선택해주세요.',
              button: '확인',
            });
            return false;
          }
        } else if (this.state.birthdayMonth === '02') {
          if (this.state.birthdayDate === '30' || this.state.birthdayDate === '31') {
            swal({
              text: '일자를 다시 선택해주세요.',
              button: '확인',
            });
            return false;
          }
        } else {
          // console.log('선택한생일', birthdayStr);
          this.setState({ birthday: birthdayStr });
        }
      }
    }

    swal({
      text: '수정하시겠습니까?',
      buttons: {
        cancle: {
          text: '취소',
          value: false,
        },
        confirm: {
          text: '확인',
          value: true,
        },
      },
      closeOnClickOutside: false,
    }).then((isAgree) => {
      if (isAgree) {
        this.uploadProfileImg(telNo, birthdayStr);
      } else {
        return false;
      }
    });
  }

  render() {
    const { classes } = this.props;
    const currentPath = this.props.location;
    const monthArr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const dateArr = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
    ];
    const phoneFirstArr = ['010', '011', '017', '016', '018', '019'];

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.background}>
          <Topbar currentPath={currentPath} />
          <div className={classes.main}>
            <div className={classes.cardDiv}>
              <Card className={classes.cardRoot}>
                <CardContent>
                  <TitleText title="회원 정보 수정" type="narrowPadding" />
                  <form name={'profileModForm'}>
                    <div style={{ display: 'table', justifyContent: 'center', position: 'relative', margin: 'auto' }}>
                      <Avatar
                        alt="user_profile"
                        src={
                          !this.state.img
                            ? '/images/mypage/default_profile.png'
                            : /^\b(uploads\/user\/.*)\b$/gi.test(this.state.img)
                            ? `http://61.254.62.162:4002/${this.state.img}`
                            : this.state.img
                        }
                        className={classes.userProfileImg}
                      />
                      <input
                        type="file"
                        // ref={this.imgPicker}
                        id={'img-picker'}
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={this.onChangeProfileImg}
                      />
                      <Fab
                        aria-label="edit"
                        classes={{
                          root: classes.fabRoot,
                        }}
                        disableRipple
                        size={!window.matchMedia('(min-width: 960px)').matches ? 'small' : 'large'}
                        onClick={this.clickChangeProfileImg}
                      >
                        <img src={'/images/mypage/ic_profile_edit.png'} alt="edit-icon" />
                      </Fab>
                    </div>
                    <div className={classes.infoContainer}>
                      <Grid container spacing={2} style={{ padding: '1em 0' }}>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} className={classes.accountInfoGrid}>
                          <Grid container spacing={2} className={classes.accountInputGrid}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <span>이</span>
                              <span>메</span>
                              <span>일</span>
                            </Grid>
                            <Grid item xs={10} sm={9} className={classes.accountInput}>
                              <OutlinedInput
                                fullWidth
                                name="emailaddr"
                                id="emailaddr"
                                type="email"
                                value={this.state.email}
                                readOnly
                                disabled
                                style={{ backgroundColor: '#fafafa', color: '#999999' }}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} className={classes.accountInputGrid}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <span>비</span>
                              <span>밀</span>
                              <span>번</span>
                              <span>호</span>
                              <span>변</span>
                              <span>경</span>
                            </Grid>
                            <Grid item xs={10} sm={9} className={classes.accountInput}>
                              <OutlinedInput
                                fullWidth
                                name="password"
                                id="password"
                                type="password"
                                disabled={this.state.st !== '' ? true : false}
                                onChange={(e) => this.setState({ password: e.target.value })}
                                value={this.state.password}
                                classes={{
                                  disabled: classes.pwdInputDisabled,
                                }}
                                style={this.state.st !== '' ? { backgroundColor: '#fafafa', color: '#999999' } : {}}
                                placeholder={this.state.st !== '' ? 'SNS 로그인 시 비밀번호 변경 불가' : ''}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <div className={classes.pwdCheckTitleWeb}>
                                <span>비</span>
                                <span>밀</span>
                                <span>번</span>
                                <span>호</span>
                                <span>변</span>
                                <span>경</span>
                                <span>확</span>
                                <span>인</span>
                              </div>
                              <div className={classes.pwdCheckTitleMobile}>비밀번호 확인</div>
                            </Grid>
                            <Grid item xs={10} sm={9} className={classes.accountInput}>
                              <OutlinedInput
                                fullWidth
                                name="passwordCheck"
                                id="passwordCheck"
                                type="password"
                                disabled={this.state.st !== '' ? true : false}
                                onChange={(e) => this.handleChange('passwordCheck', e)}
                                value={this.state.passwordCheck}
                                style={this.state.st !== '' ? { backgroundColor: '#fafafa', color: '#999999' } : {}}
                              />
                              <span style={{ color: 'rgba(85, 85, 85, 0.5)', fontSize: '0.9em' }}>
                                * 비밀번호는 영문, 숫자를 포함하고 8자 이상이어야 합니다.
                              </span>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} className={classes.userInfoGrid}>
                          <Grid container spacing={2} className={classes.infoInput}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <span>이</span>
                              <span>름</span>
                            </Grid>
                            <Grid item xs={10} sm={9}>
                              <OutlinedInput
                                fullWidth
                                name="username"
                                id="username"
                                type="text"
                                onChange={(e) => this.handleChange('name', e)}
                                value={this.state.name}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} className={classes.infoInput}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <span>연</span>
                              <span>락</span>
                              <span>처</span>
                            </Grid>
                            <Grid item xs={10} sm={9}>
                              <Grid container spacing={1}>
                                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                                  <FormControl fullWidth>
                                    <Select
                                      id="phone-first-select"
                                      variant="outlined"
                                      value={this.state.phoneFirst}
                                      onChange={(e) => this.handleChange('phoneFirst', e)}
                                      classes={{
                                        outlined: classes.outlinedSelect,
                                        input: classes.outlinedInput,
                                      }}
                                    >
                                      <MenuItem value={''} disabled>
                                        선택
                                      </MenuItem>
                                      {phoneFirstArr.map((phoneFirst, pIdx) => {
                                        return (
                                          <MenuItem value={phoneFirst} key={pIdx}>
                                            {phoneFirst}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  -
                                </Grid>
                                <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                                  <OutlinedInput
                                    fullWidth
                                    name="phoneMiddle"
                                    id="phoneMiddle"
                                    type="tel"
                                    onChange={(e) => this.handleChangeNum('phoneMiddle', e)}
                                    value={this.state.phoneMiddle}
                                    classes={{
                                      input: classes.outlinedInput,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  -
                                </Grid>
                                <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                                  <OutlinedInput
                                    fullWidth
                                    name="phoneLast"
                                    id="phoneLast"
                                    type="tel"
                                    onChange={(e) => this.handleChangeNum('phoneLast', e)}
                                    value={this.state.phoneLast}
                                    classes={{
                                      input: classes.outlinedInput,
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} className={classes.infoInput}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <span>성</span>
                              <span>별</span>
                            </Grid>
                            <Grid item xs={10} sm={9}>
                              <FormControl style={{ width: '100%' }}>
                                <Select
                                  id="gender-select"
                                  variant="outlined"
                                  value={this.state.gender}
                                  onChange={(e) => this.handleChange('gender', e)}
                                >
                                  <MenuItem value={''} disabled>
                                    선택
                                  </MenuItem>
                                  <MenuItem value={'female'}>여성</MenuItem>
                                  <MenuItem value={'male'}>남성</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} className={classes.infoInput}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <span>연</span>
                              <span>령</span>
                              <span>대</span>
                            </Grid>
                            <Grid item xs={10} sm={9}>
                              <FormControl style={{ width: '100%' }}>
                                <Select
                                  id="age-range-select"
                                  variant="outlined"
                                  value={this.state.age_range}
                                  onChange={(e) => this.handleChange('age_range', e)}
                                >
                                  <MenuItem value={''} disabled>
                                    선택
                                  </MenuItem>
                                  <MenuItem value={'10'}>10대 이하</MenuItem>
                                  <MenuItem value={'20'}>20대</MenuItem>
                                  <MenuItem value={'30'}>30대</MenuItem>
                                  <MenuItem value={'40'}>40대</MenuItem>
                                  <MenuItem value={'50'}>50대</MenuItem>
                                  <MenuItem value={'60'}>60대</MenuItem>
                                  <MenuItem value={'70'}>70대 이상</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={2} sm={3} className={classes.infoTitle}>
                              <span>생</span>
                              <span>일</span>
                            </Grid>
                            <Grid item xs={10} sm={9}>
                              <Grid container spacing={1}>
                                <Grid item xs={5} style={{ display: 'flex', alignItems: 'center' }}>
                                  <FormControl fullWidth>
                                    <Select
                                      id="birthday-month-select"
                                      variant="outlined"
                                      value={this.state.birthdayMonth}
                                      onChange={(e) => this.handleChange('birthdayMonth', e)}
                                    >
                                      <MenuItem value={''} disabled>
                                        선택
                                      </MenuItem>
                                      {monthArr.map((month, mIdx) => {
                                        return (
                                          <MenuItem value={month} key={mIdx}>
                                            {Number(month)}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center' }}>
                                  <span className={classes.infoModMonthDateText}>월</span>
                                </Grid>
                                <Grid item xs={5} style={{ display: 'flex', alignItems: 'center' }}>
                                  <FormControl fullWidth>
                                    <Select
                                      id="birthday-date-select"
                                      variant="outlined"
                                      value={this.state.birthdayDate}
                                      onChange={(e) => this.handleChange('birthdayDate', e)}
                                    >
                                      <MenuItem value={''} disabled>
                                        선택
                                      </MenuItem>
                                      {dateArr.map((date, dIdx) => {
                                        return (
                                          <MenuItem value={date} key={dIdx}>
                                            {Number(date)}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center' }}>
                                  <span className={classes.infoModMonthDateText}>일</span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                    <div>
                      <Grid container spacing={2} justify="center">
                        <Grid item>
                          <Button disableElevation color="primary" className={classes.submitBtn} onClick={() => this.submit()}>
                            수정하기
                          </Button>
                        </Grid>
                        {/* <Grid item>
                          <Button
                            disableElevation
                            // variant="contained"
                            className={classes.cancelBtn}
                            onClick={() => {
                              this.setState({ isImageSelected: false });
                              // this.props.history.goBack();
                              this.props.history.push('/');
                            }}
                          >
                    
                            메인 페이지로
                          </Button>
                        </Grid> */}
                      </Grid>
                    </div>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(MyInfoMod);
